import { DomainSummary as ServerDomainSummary, DomainSummaryOptions } from 'server/models/DomainSummary';

export { DomainSummaryOptions, DomainSummaryData } from 'server/models/DomainSummary';

export class DomainSummary extends ServerDomainSummary {
    /**
     * Does this domain not only have the Pilots module enabled but also have active Pilot Agencies using it.
     */
    HasActivePilots() {
        return this.Settings() !== null && this.Settings()!.HasPilots() && this.PilotAgencyIds().length > 0;
    }
}


// WEBPACK FOOTER //
// ./data/models/DomainSummary.ts